export const SITE_ORIGIN = 'https://www.qdpic.cn';

function seg(value) {
  return value !== undefined && value !== null && value !== '' ? String(value) : '';
}

export function buildNewsDetailUrl(id) {
  return seg(id) ? `/news/${id}` : '/news';
}

export const LATEST_NEWS_FROM = 'latest-news';

export function buildNewsDetailFromNewIndex(id) {
  return {
    path: buildNewsDetailUrl(id),
    query: { from: LATEST_NEWS_FROM },
  };
}

export function buildLatestNewsBackRoute() {
  return { path: '/news' };
}

export function buildPhotoDetailUrl(id) {
  return seg(id) ? `/photo/${id}` : '/topic_pic';
}

export function buildVideoDetailUrl(id) {
  return seg(id) ? `/video/${id}` : '/topic_video';
}

export const VISUAL_QINGDAO_FROM = 'visual-qingdao';

export function buildVideoDetailFromVisualQingdao(id) {
  return {
    path: buildVideoDetailUrl(id),
    query: { from: VISUAL_QINGDAO_FROM },
  };
}

export function buildVisualQingdaoBackRoute() {
  return { path: '/topic_video' };
}

export function buildArticleDetailUrl(id) {
  return seg(id) ? `/article/${id}` : '/';
}

export function buildArticleListUrl(id, type) {
  if (seg(id) && seg(type)) {
    return `/articles/${id}/${type}`;
  }
  return '/';
}

export function buildGalleryUrl(id) {
  return seg(id) ? `/gallery/${id}` : '/topic_pic';
}

export function buildGalleryCategoryUrl(id) {
  return seg(id) ? `/gallery/category/${id}` : '/topic_pic';
}

export function buildPhotosCategoryUrl(id) {
  return seg(id) ? `/photos/category/${id}` : '/topic_pic';
}

export function buildPhotosSubcategoryUrl(id) {
  return seg(id) ? `/photos/subcategory/${id}` : '/topic_pic';
}

export function buildSubjectDetailUrl(id) {
  return seg(id) ? `/subject/${id}` : '/subject_list';
}

export function buildStoryDetailUrl(id) {
  return seg(id) ? `/story/${id}` : '/tale';
}

export function buildStoryVideoUrl(id) {
  return seg(id) ? `/story/video/${id}` : '/tale';
}

export function buildReleaseDetailUrl(id) {
  return seg(id) ? `/release/${id}` : '/publish';
}

export function buildReleaseVideoUrl(id) {
  return seg(id) ? `/release/video/${id}` : '/publish';
}

export function buildIntlCateUrl(id) {
  return seg(id) ? `/international/cate/${id}` : '/international';
}

export function buildIntlDetailUrl(id) {
  return seg(id) ? `/intl/${id}` : '/international';
}

export function buildIntlVideoUrl(id) {
  return seg(id) ? `/intl/video/${id}` : '/international';
}

export function buildPhotographerDetailUrl(id) {
  return seg(id) ? `/photographer/${id}` : '/photo_grapher';
}

export function buildPhotographersCategoryUrl(id) {
  return seg(id) ? `/photographers/category/${id}` : '/photo_grapher';
}

export function buildActivityNewsUrl(id) {
  return seg(id) ? `/activity-news/${id}` : '/active_list';
}

/** 活动征集主页：/active?id=80 → /active/80 */
export function buildActiveUrl(actid) {
  return seg(actid) ? `/active/${actid}` : '/active_list';
}

export function buildActiveDetailUrl(id = 0, type = 0, actid) {
  if (seg(actid)) {
    return `/activity/${id || 0}/${type || 0}/${actid}`;
  }
  return '/active_list';
}

export function buildCollectPhotoUrl(id) {
  return seg(id) ? `/collect/photo/${id}` : '/active_list';
}

export function buildCollectVideoUrl(id) {
  return seg(id) ? `/collect/video/${id}` : '/active_list';
}

export function buildCanonicalUrl(path) {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${SITE_ORIGIN}${normalized}`;
}

/** 开发环境：旧 query URL → SEO path（与 Nginx 301 行为一致） */
export function resolveLegacySeoPath(path, query = {}) {
  const q = query;
  switch (path) {
    case '/news_detail':
      return seg(q.id) ? buildNewsDetailUrl(q.id) : '/news';
    case '/topic_pic_detail':
      return buildPhotoDetailUrl(q.id);
    case '/topic_video_detail':
      return buildVideoDetailUrl(q.id);
    case '/article_detail':
      return buildArticleDetailUrl(q.id);
    case '/article_list':
      return buildArticleListUrl(q.id, q.type);
    case '/special_topics':
      return buildGalleryUrl(q.catid);
    case '/special_topics_category':
      return buildGalleryCategoryUrl(q.catid);
    case '/topic_pic_category':
      return buildPhotosCategoryUrl(q.catid);
    case '/topic_pic_subcategory':
      return buildPhotosSubcategoryUrl(q.catid);
    case '/subject_detail':
      return buildSubjectDetailUrl(q.id);
    case '/tale_detail':
      return buildStoryDetailUrl(q.id);
    case '/tale_video':
      return buildStoryVideoUrl(q.id);
    case '/publish_detail':
      return buildReleaseDetailUrl(q.id);
    case '/publish_video':
      return buildReleaseVideoUrl(q.id);
    case '/international_detail':
      return buildIntlDetailUrl(q.id);
    case '/international_video':
      return buildIntlVideoUrl(q.id);
    case '/photo_grapher_detail':
      return buildPhotographerDetailUrl(q.id);
    case '/photo_grapher':
      return seg(q.catid) ? buildPhotographersCategoryUrl(q.catid) : null;
    case '/related_news_detail':
      return buildActivityNewsUrl(q.id);
    case '/active':
      return seg(q.id) ? buildActiveUrl(q.id) : null;
    case '/active_detail':
      return buildActiveDetailUrl(q.id || 0, q.type || 0, q.actid);
    case '/active_collect_detail':
      return buildCollectPhotoUrl(q.id);
    case '/active_collect_video_detail':
      return buildCollectVideoUrl(q.id);
    default:
      return null;
  }
}
